// extracted by mini-css-extract-plugin
module.exports = {"buyKit":"buyKit_buyKit__qNRWL"};